import { Utility } from "../../../../../common/utility";

export class CustomdHeaderAction {
    public actionJSON: any = {};
    private utility: Utility;

    constructor(actionObject: any) {
        this.utility = new Utility();
        this.formActionJSON(actionObject);
    }
    formActionJSON(actionObject: any) {
            if (actionObject.isVisible === 'true') {
                this.actionJSON = {
                    headerFormRules: {
                        [actionObject.name]: {
                            fields: actionObject.visibilityRuleFields,
                            visible: actionObject.visibilityRuleObj.visible
                        }
                    }
                }
            } else {
                this.actionJSON = {
                    headerFormRules: {
                        [actionObject.name]: {
                            fields: [],
                            visible: actionObject.visibilityRuleObj.visible
                        }
                    }
                }
            }
            const compName =  actionObject.actionType === 'VF_PAGE' ? actionObject.componentName : this.utility.toKebabStyle(actionObject.componentName);
            actionObject.isRuleApplied?
                (this.actionJSON = {
                    ...this.actionJSON,
                    headerActions: {
                        name: actionObject.name,
                        label: actionObject.label,
                        bulk: actionObject.isBulkChecked,
                        componentName: compName,
                        component_namespace: actionObject.componentNameSpace,
                        action_type: actionObject.actionType,
                        inputList:{
                            urlparam:actionObject.inputList
                        }
                    }
                }):
                (this.actionJSON = {
                    headerActions: {
                        name: actionObject.name,
                        label: actionObject.label,
                        bulk: actionObject.isBulkChecked,
                        componentName: compName,
                        component_namespace: actionObject.componentNameSpace,
                        action_type: actionObject.actionType,
                        inputList:{
                            urlparam:actionObject.inputList
                        }
                    }
                })
        return this.actionJSON;
    }

}